module.exports = __webpack_public_path__ + "static/media/triangle-right.367018f9.svg";